import { render } from "./AmoCrmCustomers.vue?vue&type=template&id=4b55924f&scoped=true&ts=true"
import script from "./AmoCrmCustomers.vue?vue&type=script&lang=ts"
export * from "./AmoCrmCustomers.vue?vue&type=script&lang=ts"

import "./AmoCrmCustomers.vue?vue&type=style&index=0&id=4b55924f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b55924f"]])

export default __exports__